export const addFieldArrayObject = async (array, field, value) => {
    array.forEach(element => {
        element[field] = value
    });
}

export const filterArrayEqual = (array, field,  value) => {
        return array.filter(data => {
                    if (data[field] === value)
                        return true
                    else 
                        return false
                })
}
export const filterArrayMoreEqual = (array, field,  value) => {
    let arrResult = []
    for (let i = 0; i < value.length; i++) {
        for (let j = 0; j < array.length; j++) {
            if(value[i] === array[j][field]) {
                arrResult = [...arrResult, array[j]]
            }
        }
    }
    return arrResult
}

export const filterArrayLessEqual = (array, field,  value) => {
    let result = array
    for (let index = 0; index < value.length; index++) {
        result = result.filter(data => {
            if (data[field] !== value[index])
                return true
            else 
                return false
        })
    }
    return result
}

export const filterArrayNotEqual = (array, field,  value) => {
    return array.filter(data => {
                if (data[field] !== value)
                    return true
                else 
                    return false
            })
}

export const filterArrayNotEqualAccountJoint = (array, field,  value) => {
    return array.filter(data => {
                if ((data[field] !== value) && (data["TipoFirma"]  !== "CONJUNTA"))
                    return true
                else 
                    return false
            })
}

export const isEmpty = (obj) => {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

export const arrayhierarchy = (array, hierachy, key) => {
    // console.log(array, hierachy)
    let arrResult = []
    for (let i = 0; i < hierachy.length; i++) {
        for (let j = 0; j < array.length; j++) {
            if(hierachy[i] === array[j][key]) {
                arrResult = [...arrResult, array[j]]
            }
        }
    }

    return arrResult;
}

export const groupBy = (xs, key) => {
    return xs.reduce(function(rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
};

export const arrayEmptyField = (array, fields) => {
    let arrayResult = array
    let c = 0
    array.map((object, i) => {
        // const isEmpty = Object.values(object).every(x => x === null || x === '');
        let result = ''
        fields.forEach((element, i) => {
            if (object[element] === undefined) {
                result = result + ` ${c !== 0 ? ',' : ''}${element.toUpperCase()} ESTA VACIO`
                c++
            }
        });
        return arrayResult[i].validate = result
    })
    // console.log('RETORNANDO', arrayResult)
    return arrayResult
}

export const arrayExistDuplicate = (array, field) => {
    let final = [...array.reduce((op, inp) => {
      let fieldData = inp[field]
      op.set(fieldData, (op.get(fieldData) || 0) + 1)
      return op
    }, new Map()).entries()].filter(([_,repeat]) => repeat > 1).map(([fieldData, repeat]) => ({
      fieldData,
      repeat
    }))
    return final
}